import React from "react";
// Customizable Area Start

import {
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TablePagination,
  TableCell,
  TableBody,
  Table,
  Box,
  IconButton,
  Popover,
  Modal,
  Button,
  Typography,
  TextField,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import AddIcon from "@material-ui/icons/Add";

import PermanentTagsListController, { Props, IAddTagForm } from "./PermanentTagsListController.web";
import { configJSON } from "./PermanentTagsListController.web";
import SortingTableHeader from "../../../components/src/SortingTableHeader";
import SortingTableCell from "../../../components/src/SortingTableCell";
import PageHeader from "../../../components/src/PageHeader";
import FilterPopover, { IFilter } from "../../../components/src/FilterPopover";
import FilterIcon from "@material-ui/icons/FilterList";
import { FilterBox } from "../../../components/src/customComponents/CustomTags.web";
import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import { renderBaseOnConditions, sortStringCondition } from "../../../blocks/utilities/src/CustomBlockHelpers";

export default class PermanentTagsList extends PermanentTagsListController {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const rows = this.state.permanentTags.map((tag) => {
      const tagCode = tag?.attributes?.tag_code || "";
      const productName = tag?.relationships?.catalogue?.data?.name || "";
      const serviceName = tag?.relationships?.service?.data?.short_name || "";
      const status = tag?.attributes?.status || "";
      const id = String(tag?.id) || "";

      return this.createData(tagCode, productName, serviceName, status, id);
    });

    const filteredRows = rows.slice(
      this.state.page * this.state.pageSize,
      (this.state.page + 1) * this.state.pageSize
    );
    const emptyRows = this.state.pageSize - filteredRows.length;
    const sortingData = this.state.sortingData;
    const { selectedTag, addTagForm } = this.state;

    return (
      <>
        <Box style={webStyle.mainWrapper}>
          <Box>
            <Box className="pageWrapper">
              <PageHeader
                data-test-id='permanentTagsListHeader'
                header={configJSON.permanentTagsHeader}
                permissionStatus={this.state.permissionStatus.createPermission}
                buttonText={""}
                onButtonClick={() => {}}
                filterComponent={
                  <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                    {this.state.permissionStatus.createPermission && (
                      <Button
                        data-test-id='addTagBtn'
                        style={webStyle.addTagButton}
                        onClick={this.handleAddTag}
                        startIcon={<AddIcon />}
                      >
                        Add Tag
                      </Button>
                    )}
                    <FilterBox
                      data-test-id='filterBtn'
                      className={sortStringCondition(
                        this.state.isAppliedFilter,
                        "active-border",
                        ""
                      )}
                      onClick={(event) => {
                        this.setState({
                          filterAnchor: event.currentTarget,
                        });
                      }}
                    >
                      <FilterIcon color={this.handleReturnColorType()} />
                      {renderBaseOnConditions(
                        this.state.isAppliedFilter,
                        <div className="filterActiveIcon"></div>,
                        <></>
                      )}
                    </FilterBox>
                    <FilterPopover
                      anchor={this.state.filterAnchor}
                      onClose={() => {
                        this.setState({ filterAnchor: undefined });
                      }}
                      onAutoCompleteChange={(title: string, value: string) => {
                        this.setState({ suggestionFieldTitle: title });
                        this.handleAutoComplete(title, value);
                      }}
                      onClearFilter={() => {
                        let updated = this.state.filters.map((item: IFilter) => {
                          item.value = "";
                          item.options = [];
                          return item;
                        });
                        this.setState({ filters: updated });
                      }}
                      filters={this.state.filters}
                      onFilterChange={this.handleFilterChange}
                    />
                  </div>
                }
              />
              <TableContainer component={Paper} className="flexItem">
                <Table style={webStyle.table} aria-label='customized table'>
                  <TableHead className="stickyHeader">
                    <TableRow
                      style={{ background: "#204B9C", color: "#FFFFFF" }}
                    >
                      <SortingTableHeader
                        sortingData={sortingData}
                        title={configJSON.tagCode}
                        sortingKey='tag_code'
                        {...this.sortingProps}
                        type='left'
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title={configJSON.productName}
                        sortingKey=''
                        {...this.sortingProps}
                        sortingDisabled
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title={configJSON.serviceName}
                        sortingKey=''
                        {...this.sortingProps}
                        sortingDisabled
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title={configJSON.status}
                        sortingKey=''
                        {...this.sortingProps}
                        sortingDisabled
                      />
                      <SortingTableHeader
                        sortingData={sortingData}
                        title=''
                        sortingKey=''
                        {...this.sortingProps}
                        type='action'
                        sortingDisabled
                      />
                    </TableRow>
                  </TableHead>
                  {!this.state.isLoading && filteredRows.length > 0 &&
                    <TableBody>
                      {filteredRows.map((rowData, index) => (
                        <TableRow key={index + "TableRow"}>
                          <SortingTableCell
                            width='20vw'
                            type='left'
                            content={rowData.tagCode}
                          />
                          <SortingTableCell
                            width='25vw'
                            content={rowData.productName}
                          />
                          <SortingTableCell
                            width='20vw'
                            content={rowData.serviceName}
                          />
                          <SortingTableCell
                            width='15vw'
                            content={
                              <Button
                                data-test-id={`viewHistoryBtn-${rowData.id}`}
                                style={webStyle.viewHistoryButton}
                                onClick={() => this.getCustomerUsageHistory(rowData.id)}
                              >
                                View
                              </Button>
                            }
                          />
                          <SortingTableCell
                            data-test-id='moreBtnTableCell'
                            width='10vw'
                            type='action'
                            content={
                              <IconButton
                                data-test-id={`moreButton-${rowData.id}`}
                                id={"IconButton" + index}
                                onClick={(event) => {
                                  const position = event.currentTarget.getBoundingClientRect();
                                  this.setState({
                                    popOverOpened: true,
                                    popOverItemId: rowData.id,
                                    popOverItemStatus: rowData.status,
                                    popOverLeft: position.left + window.scrollX,
                                    popOverTop: position.top + window.scrollY,
                                  });
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            }
                          />
                        </TableRow>
                      ))}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={5} />
                        </TableRow>
                      )}
                    </TableBody>
                  }
                  {this.state.isLoading &&
                    <>{Array(5)
                      .fill(1)
                      .map((_, index) => (
                        <TableBody key={index} data-test-id='tableData'>
                          <TableRow>
                            {[...Array(5)].map((_, cellIndex) => (
                              <TableRowsSkeleton key={cellIndex} />
                            ))}
                          </TableRow>
                        </TableBody>
                      ))}</>
                  }
                </Table>
                {!this.state.isLoading && filteredRows.length === 0 && (
                  <div
                    style={{
                      fontSize: 16,
                      width: "100%",
                      textAlign: "center",
                      fontWeight: 602,
                    }}
                  >
                    {configJSON.noRecordFound}
                  </div>
                )}

                {/* Actions Popover */}
                <Popover
                  data-test-id="actionsPopover"
                  open={this.state.popOverOpened}
                  onClose={() => this.setState({ popOverOpened: false })}
                  anchorReference="anchorPosition"
                  anchorPosition={{
                    top: this.state.popOverTop + 40,
                    left: this.state.popOverLeft - 80,
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <div style={webStyle.popoverContainer}>
                    <Box
                      data-test-id='viewButton'
                      onClick={() => this.handleViewTag(this.state.popOverItemId)}
                      sx={webStyle.popoverButton}
                    >
                      View
                    </Box>
                    <Box
                      data-test-id='editButton'
                      onClick={() => this.handleEditTag(this.state.popOverItemId)}
                      sx={webStyle.popoverButton}
                    >
                      Edit
                    </Box>
                    <Box
                      data-test-id='deleteButton'
                      onClick={() => this.handleDeleteTag(this.state.popOverItemId)}
                      sx={webStyle.popoverButton}
                    >
                      Delete
                    </Box>
                  </div>
                </Popover>
              </TableContainer>
              {filteredRows.length > 0 && (
                <TablePagination
                  rowsPerPageOptions={[25]}
                  data-test-id='pagination'
                  component='div'
                  rowsPerPage={this.state.pageSize}
                  onPageChange={this.handlePageChange}
                  count={rows.length}
                  page={this.state.page}
                />
              )}
            </Box>
          </Box>

          {/* View Details Modal */}
          {this.state.openViewDialog && (
            <Modal
              open={this.state.openViewDialog}
              data-test-id='view_details_modal'
              onClose={this.handleCloseViewDialog}
              aria-labelledby='modal-modal-title'
              aria-describedby='modal-modal-description'
            >
              <Box sx={webStyle.modalStyle}>
                <Typography style={webStyle.modalHeading}>
                  Permanent Tag Details
                </Typography>
                {selectedTag && (
                  <Box style={webStyle.detailsContainer}>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Tag Code:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.attributes?.tag_code || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Prefix:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.attributes?.prefix || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Number:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.attributes?.number || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Status:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.attributes?.status || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Product Name:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.relationships?.catalogue?.data?.name || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Service:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.relationships?.service?.data?.short_name || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Service Name:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.relationships?.service?.data?.name || "-"}</Typography>
                    </Box>
                    <Box style={webStyle.detailRow}>
                      <Typography style={webStyle.detailLabel}>Price:</Typography>
                      <Typography style={webStyle.detailValue}>{selectedTag.relationships?.catalogues_service?.data?.price || "-"}</Typography>
                    </Box>
                  </Box>
                )}
                <Button
                  data-test-id='closeViewModal'
                  style={webStyle.modalCancelBtn}
                  onClick={this.handleCloseViewDialog}
                >
                  Close
                </Button>
              </Box>
            </Modal>
          )}

          {/* Add Tag Modal */}
          {this.state.openAddDialog && (
            <Modal
              open={this.state.openAddDialog}
              data-test-id='add_tag_modal'
              onClose={this.handleCloseAddDialog}
              aria-labelledby='modal-add-title'
              aria-describedby='modal-add-description'
            >
              <Box sx={webStyle.modalStyle}>
                <Typography style={webStyle.modalHeading}>
                  Add Permanent Tag
                </Typography>
                <Box style={webStyle.formContainer}>
                  <TextField
                    data-test-id='prefixInput'
                    label="Prefix"
                    variant="outlined"
                    fullWidth
                    value={addTagForm.prefix}
                    onChange={(e) => this.handleAddTagFormChange("prefix", e.target.value)}
                    style={webStyle.formField}
                    placeholder="e.g., AB"
                  />
                  <TextField
                    data-test-id='numberInput'
                    label="Number"
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={addTagForm.number}
                    onChange={(e) => this.handleAddTagFormChange("number", e.target.value)}
                    style={webStyle.formField}
                    placeholder="e.g., 50111"
                  />
                  <TextField
                    data-test-id='catalogueIdInput'
                    label="Catalogue ID"
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={addTagForm.catalogue_id}
                    onChange={(e) => this.handleAddTagFormChange("catalogue_id", e.target.value)}
                    style={webStyle.formField}
                    placeholder="e.g., 123"
                  />
                  <TextField
                    data-test-id='serviceIdInput'
                    label="Service ID"
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={addTagForm.service_id}
                    onChange={(e) => this.handleAddTagFormChange("service_id", e.target.value)}
                    style={webStyle.formField}
                    placeholder="e.g., 45"
                  />
                  <TextField
                    data-test-id='statusInput'
                    label="Status"
                    variant="outlined"
                    fullWidth
                    select
                    value={addTagForm.status}
                    onChange={(e) => this.handleAddTagFormChange("status", e.target.value)}
                    style={webStyle.formField}
                  >
                    <MenuItem value="available">Available</MenuItem>
                    <MenuItem value="assigned">Assigned</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </TextField>
                </Box>
                <Box style={webStyle.modalButtonContainer}>
                  <Button
                    data-test-id='cancelAddModal'
                    style={webStyle.modalCancelBtn}
                    onClick={this.handleCloseAddDialog}
                  >
                    Cancel
                  </Button>
                  <Button
                    data-test-id='submitAddModal'
                    style={webStyle.modalSubmitBtn}
                    onClick={this.handleCreateTag}
                    disabled={this.state.isSubmitting}
                  >
                    {this.state.isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Add Tag"}
                  </Button>
                </Box>
              </Box>
            </Modal>
          )}

          {/* Customer Usage History Modal */}
          {this.state.openCustomerHistoryDialog && (
            <Modal
              open={this.state.openCustomerHistoryDialog}
              data-test-id='customer_history_modal'
              onClose={this.handleCloseCustomerHistoryDialog}
              aria-labelledby='modal-history-title'
              aria-describedby='modal-history-description'
            >
              <Box sx={{ ...webStyle.modalStyle, width: "800px" }}>
                <Typography style={webStyle.modalHeading}>
                  Customer Usage History
                </Typography>
                {this.state.isLoadingCustomerHistory ? (
                  <Box style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    {this.state.customerHistoryData && (
                      <Box style={webStyle.detailsContainer}>
                        <Box style={webStyle.detailRow}>
                          <Typography style={webStyle.detailLabel}>Tag Code:</Typography>
                          <Typography style={webStyle.detailValue}>
                            {this.state.customerHistoryData.permanent_tag?.tag_code || "-"}
                          </Typography>
                        </Box>
                        <Box style={webStyle.detailRow}>
                          <Typography style={webStyle.detailLabel}>Status:</Typography>
                          <Typography style={webStyle.detailValue}>
                            {this.state.customerHistoryData.permanent_tag?.status || "-"}
                          </Typography>
                        </Box>
                        <Box style={webStyle.detailRow}>
                          <Typography style={webStyle.detailLabel}>Total Customers:</Typography>
                          <Typography style={webStyle.detailValue}>
                            {this.state.customerHistoryData.total_customers || 0}
                          </Typography>
                        </Box>
                        <Box style={webStyle.detailRow}>
                          <Typography style={webStyle.detailLabel}>Total Wash Count:</Typography>
                          <Typography style={webStyle.detailValue}>
                            {this.state.customerHistoryData.total_usages || 0}
                          </Typography>
                        </Box>

                        {this.state.customerHistoryData.customer_history &&
                          this.state.customerHistoryData.customer_history.length > 0 && (
                          <Box style={{ marginTop: "16px" }}>
                            <Typography style={{ ...webStyle.detailLabel, marginBottom: "12px" }}>
                              Customer History:
                            </Typography>
                            <TableContainer component={Paper} style={{ maxHeight: "300px" }}>
                              <Table size="small" stickyHeader>
                                <TableHead>
                                  <TableRow style={{ background: "#204B9C" }}>
                                    <TableCell style={webStyle.historyTableHeader}>Customer Name</TableCell>
                                    <TableCell style={webStyle.historyTableHeader}>Wash Count</TableCell>
                                    <TableCell style={webStyle.historyTableHeader}>Last Used</TableCell>
                                    <TableCell style={webStyle.historyTableHeader}>Last Used Store</TableCell>
                                    <TableCell style={webStyle.historyTableHeader}>Last Used Order #</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {this.state.customerHistoryData.customer_history.map((customer, index) => (
                                    <TableRow key={index}>
                                      <TableCell style={webStyle.historyTableCell}>
                                        {customer.customer_name || "-"}
                                      </TableCell>
                                      <TableCell style={webStyle.historyTableCell}>
                                        {customer.usage_count || 0}
                                      </TableCell>
                                      <TableCell style={webStyle.historyTableCell}>
                                        {this.formatLastUsedDate(customer.last_used_at)}
                                      </TableCell>
                                      <TableCell style={webStyle.historyTableCell}>
                                        {customer.last_used_store?.store_name || "-"}
                                      </TableCell>
                                      <TableCell style={webStyle.historyTableCell}>
                                        {customer.last_used_order_invoice_number ? `#${customer.last_used_order_invoice_number}` : "-"}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        )}

                        {(!this.state.customerHistoryData.customer_history ||
                          this.state.customerHistoryData.customer_history.length === 0) && (
                          <Box style={{ textAlign: "center", padding: "16px", color: "#64748B" }}>
                            No customer history found
                          </Box>
                        )}
                      </Box>
                    )}
                  </>
                )}
                <Button
                  data-test-id='closeHistoryModal'
                  style={webStyle.modalCancelBtn}
                  onClick={this.handleCloseCustomerHistoryDialog}
                >
                  Close
                </Button>
              </Box>
            </Modal>
          )}
        </Box>
      </>
    );
  }
}

const webStyle = {
  table: {
    minWidth: 700,
  },
  mainWrapper: {
    fontFamily: "Montserrat",
  },
  pageHeader: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "29px",
  },
  headerWrapper: {
    justifyContent: "space-between",
    display: "flex",
    marginBottom: 32,
    alignItems: "center",
  },
  addTagButton: {
    background: "#204B9C",
    fontWeight: 600,
    fontSize: "16px",
    color: "#FFFFFF",
    lineHeight: "24px",
    height: "56px",
    width: "184px",
    borderRadius: "8px",
    textTransform: "none" as const,
    "&:hover": {
      background: "#204B9C",
    },
  },
  filterButton: {
    cursor: "pointer",
    padding: "16px",
    border: "solid 1px rgba(32, 75, 156, 1)",
    borderRadius: "15px",
  },
  popoverContainer: {
    paddingTop: "16px",
    paddingBottom: "16px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.03), 0px 8px 32px rgba(0, 0, 0, 0.06)",
    borderRadius: "8px",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "14px",
  },
  popoverButton: {
    cursor: "pointer",
    width: "118px",
    height: "33px",
    paddingLeft: "24px",
    backgroundColor: "#FFFFFF",
    color: "#4D4D4D",
    "&:hover": {
      backgroundColor: "#204B9C",
      color: "#FFFFFF",
    },
    paddingTop: "8px",
  },
  modalStyle: {
    maxHeight: "calc(100vh - 126px)",
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    bgcolor: "#fff",
    borderRadius: "12px",
    boxShadow: 24,
    padding: "24px",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    overflowY: "auto" as const,
  },
  modalHeading: {
    fontSize: "24px",
    lineHeight: "24px",
    fontFamily: "Montserrat",
    fontWeight: 600,
    margin: "0 0 24px 0",
  },
  detailsContainer: {
    width: "100%",
    marginBottom: "16px",
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: "1px solid #E2E8F0",
  },
  detailLabel: {
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: "14px",
    color: "#64748B",
  },
  detailValue: {
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "14px",
    color: "#1E293B",
  },
  formContainer: {
    width: "100%",
    marginBottom: "16px",
  },
  formField: {
    marginBottom: "16px",
  },
  modalButtonContainer: {
    display: "flex",
    gap: "16px",
    marginTop: "16px",
  },
  modalCancelBtn: {
    minHeight: "56px",
    width: "126px",
    backgroundColor: "rgba(32, 75, 156, 0.1)",
    borderRadius: "8px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(100, 116, 139, 1)",
    fontWeight: 600,
    textTransform: "capitalize" as const,
  },
  modalSubmitBtn: {
    minHeight: "56px",
    width: "126px",
    backgroundColor: "#204B9C",
    borderRadius: "8px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    fontWeight: 600,
    textTransform: "capitalize" as const,
    "&:hover": {
      backgroundColor: "#1a3d7c",
    },
  },
  viewHistoryButton: {
    backgroundColor: "#204B9C",
    color: "#FFFFFF",
    fontSize: "12px",
    fontWeight: 500,
    padding: "4px 12px",
    borderRadius: "4px",
    textTransform: "none" as const,
    minWidth: "auto",
    height: "28px",
  },
  historyTableHeader: {
    backgroundColor: "#204B9C",
    color: "#FFFFFF",
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: "14px",
  },
  historyTableCell: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    color: "#1E293B",
  },
};

// Customizable Area End
